import type { FaireProductEntity } from "../../entity_types/product";

export const p_c776d482m8: FaireProductEntity = {
  token: "p_c776d482m8",
  type: "product",
  name: "Bitch Relax Bath Salts 12oz Bag",
  brandToken: "b_5pzqc98s7c",
  brandName: "Explicit Essentials",
  imageUrl:
    "https://cdn.faire.com/fastly/d54dae21de4987c39e73d4c37f7604fbe2b5ab81fc0c7de0005cb9ffa070aea6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc141a56dd295ffd3d53eca32b10e1e87d1b283eee8b915d8ac34f41f46b01b5.png",
    "https://cdn.faire.com/fastly/06c0ece418682cb7bbd51258afee5ed35cfc3778cd362b2744cb1d5da524ffff.jpeg",
    "https://cdn.faire.com/fastly/e928389ab10e946b8246ed34f1fd94e8dc3d53bdf54daae47d62c6b7f9fa5c0a.jpeg",
    "https://cdn.faire.com/fastly/b0b4fa6eb04cdfb23e1c56ec59a065e951e0a293e227ef379b4764c53d5411c5.jpeg",
    "https://cdn.faire.com/fastly/f5fcec8b96c8d539dadfa5e05fe0dad6c826e38abf56b2d5d4c76757cda9800b.jpeg",
    "https://cdn.faire.com/fastly/7d17e083ad23411ba045cfbb30687681591c04eb716b3d2f575180e203956d97.jpeg",
    "https://cdn.faire.com/fastly/bee5c8d8149aaf5c32046ab315a2507b822f7ab328e984ef7137016f1466b747.jpeg",
    "https://cdn.faire.com/fastly/d9f43bc21a9d21e1d48024b794b4213dfd30de6fb142aa9e4d97dae401ce053b.jpeg",
    "https://cdn.faire.com/fastly/986b76c386ce06d3a0d32abc7881df36939f374d2fd6e73a002c9c396941501f.jpeg",
    "https://cdn.faire.com/fastly/8c45b22171279a3cc597ccabf65921b315626c6570edab51b95c72755946e41c.jpeg",
    "https://cdn.faire.com/fastly/6cc9203c967335598a181fdad536cd4ce54f9b21d2608c9417537b848722218e.jpeg",
    "https://cdn.faire.com/fastly/45e551aa12375f125d39d711c8fd23f541cba47a341c488a9c796267333f477c.jpeg",
  ],
  priceDollars: 7.49,
  description:
    " This 12 oz bag of lavender mint bath salts is the perfect treat for women in need of some pampering. Immerse yourself in the calming scent of lavender, while the refreshing hint of mint revitalizes your senses. Whether you're looking to unwind after a long day or simply want to elevate your self-care routine, these bath salts are a must-have. Treat yourself or surprise a loved one with this luxurious gift that promotes relaxation and rejuvenation. Get ready to sink into a state of pure bliss with Bitch Relax Bath Salts.\n\nLAVENDER & SWEET MINT\nBright refreshing notes of crushed mint leaves and lavender.\n\n•Cruelty Free\n•Women Owned and Operated\n•Ships Fast and Free\n•Premium Ingredients",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:28.853Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
